import { FirestoreCollections } from '@griply/types';
import { orderBy } from 'firebase/firestore';

import { lifescanConverter } from './converters/lifescan';
import { getAuthentication, getCollection, query, where } from './helpers';

export const getLifescans = async () => {
  const auth = await getAuthentication();

  const conditions = [
    where('roles.all', 'array-contains', auth.currentUser?.uid),
  ];

  return query(
    getCollection(FirestoreCollections.Lifescans).withConverter(
      lifescanConverter,
    ),
    ...conditions,
    orderBy('createdAt', 'desc'),
  );
};
